import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants';

import type { Poll } from '@/types/poll';

const KEYS = {
    all: ['poll'] as const,
    detail: (slug: string) => [...KEYS.all, 'detail', slug] as const,
};

export { KEYS as POLL_DETAIL_KEYS };

export function usePoll(slug: string) {
    return useQuery({
        queryKey: KEYS.detail(slug),
        queryFn: async () => {
            const { data } = await api.get<Poll>(API_ROUTES.pollDetail(slug));
            return data;
        },
        enabled: !!slug,
    });
}
